'use strict';

angular.module('licensure.services')
    .factory('Queries', ['$http', '$q', function ($http, $q) {
        return {
            get: function (state, availableOnly) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/queries/getqueries', {
                        params: {
                            state: state,
                            availableOnly: availableOnly
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/queries/getquery/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getColumns: function (page) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/queries/getcolumns/' + page, {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getFilters: function (page) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/queries/getfilters/' + page, {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getAdvancedFilters: function (page) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/queries/getadvancedfilters/' + page, {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getFields: function (page) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/queries/getfields/' + page, {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getField: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/queries/getfield/' + id, {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getSecurityGroups: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/queries/getsecuritygroups/', {
                        params: {
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (query, default_view) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/queries/";
                if (!isUndefined(query.id)) {
                    method = "PUT";
                    url += query.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        query: query,
                        default_view: default_view,
                        columns: query.query_column_values,
                        filters: query.query_filter_values,
                        advanced_filters: query.query_advanced_filter_values,
                        criteria: query.query_criteria,
                        view_groups: query.query_security_group_viewers,
                        edit_groups: query.query_security_group_editors,
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/queries/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }

        }
    }])
    ;